import { render } from "./AppSigningComplete.vue?vue&type=template&id=285ca9cb&scoped=true"
import script from "./AppSigningComplete.vue?vue&type=script&lang=js"
export * from "./AppSigningComplete.vue?vue&type=script&lang=js"

import "./AppSigningComplete.vue?vue&type=style&index=0&id=285ca9cb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285ca9cb"]])

export default __exports__